import { useContext, useState } from 'react'
import Modal, { ModalBody, ModalHeader } from '../../common/Modal'
import { ConnectorViewMappingContext } from './context/context'
import InputText from '../../common/InputText'
import { putRequest } from '../../../services/base'
import { useParams } from 'react-router-dom'
import { NavContext } from '../../../context/global_context'
import { getRandomString } from '../../../utils/common'
import NoRecordsFound from '../../common/NoRecordsFound'
import { TrashAlt } from '@styled-icons/boxicons-solid'
import Tooltip from '../../common/tooltip'
import Button from '../../common/Button'

const DuplicateReferences = () => {
  const { connector_view } = useParams()
  const [state, dispatch] = useContext(ConnectorViewMappingContext)
  const [navState, navDispatch] = useContext(NavContext)

  const [showReferenceModal, setShowReferenceModal] = useState(false)
  const [referenceValue, setReferenceValue] = useState('')
  const [references, setReferences] = useState([])
  const [searchSelectedRefVal, setSearchSelectedRefVal] = useState('')
  const [selectedRefVal, setSelectedRefVal] = useState(null)

  const selectReference = (ref) => {
    setSelectedRefVal(ref)
    getNewGroupIds(ref)
  }

  const getNewGroupIds = async (reference) => {
    for (let index = 1; index < 1000; index++) {
      let tempRef = `${reference}_${index}`
      const referenceExists = references.some(
        (reference) => reference.new === tempRef
      )
      if (
        !state?.connector_view?.group_ids.includes(tempRef) &&
        !referenceExists
      ) {
        let temp = [...references]
        temp.push({ old: reference, new: tempRef })
        setReferences(temp)
        break
      }
    }
  }

  const saveDuplicateRef = async () => {
    if (window.confirm(`Are you sure want save selected references`) === true) {
      navDispatch({
        type: 'loader',
        data: {
          caption: `Saving Duplicate References`,
          showLoader: true,
        },
        notification: {},
      })

      let res = await putRequest(
        `/api/connector_views/save_references/${connector_view}/`,
        {
          references: references,
        }
      )
      if (res?.status) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: res?.msg,
          },
        })

        dispatch({
          type: 'connector_view',
          data: {
            ...state.connector_view,
            group_ids: res?.data?.group_ids,
            svg: `${res?.data.svg.split('?string=')[0]}?string=${getRandomString()}`,
          },
        })
        resetReferences()
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
          },
        })
        resetReferences()
      }
    }
  }

  const resetReferences = () => {
    setShowReferenceModal(false)
    setReferenceValue('')
    setReferences([])
  }

  const deleteReference = (idx, reference) => {
    let tempReferences = [...references]
    tempReferences.splice(idx, 1)
    setReferences(tempReferences)
  }

  return (
    <div>
      <button
        type="button"
        className="cursor-pointer bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-2 rounded text-base"
        onClick={() => {
          setShowReferenceModal(true)
        }}
      >
        Duplicate Reference
      </button>

      <Modal
        onClose={() => {
          setShowReferenceModal(false)
        }}
        show={showReferenceModal}
        size={`w-full`}
      >
        <ModalHeader className={'text-white'}>
          Select References To create duplicate
        </ModalHeader>
        <ModalBody>
          <div className="flex">
            <div className="w-3/4 px-2" style={{ borderRight: '1px solid' }}>
              <div className="flex justify-between items-center text-base">
                <InputText
                  name="search_reference"
                  onChange={(e) => {
                    setReferenceValue(e)
                  }}
                  label={'Search References'}
                  isRequired={false}
                  value={referenceValue}
                  type={'search'}
                />
              </div>
              <div
                className="flex items-center flex-wrap overflow-y-auto p-2"
                style={{ maxHeight: '50vh' }}
              >
                {state?.connector_view?.group_ids
                  ?.filter((gr) =>
                    gr
                      .toLocaleLowerCase()
                      .includes(referenceValue.toLocaleLowerCase())
                  )
                  .map((group, groupIdx) => {
                    return (
                      <div
                        className={`p-1 text-sm border-1 border mr-2 mb-2 cursor-pointer ${selectedRefVal === group && 'bg-tracer-lt-blue'}`}
                        key={`group-${groupIdx}`}
                        onClick={() => {
                          selectReference(group)
                        }}
                      >
                        {group}
                      </div>
                    )
                  })}
              </div>
            </div>
            <div className="w-1/4 px-2">
              <div className="flex justify-between items-center text-base">
                <InputText
                  name="search_selected_reference"
                  onChange={(e) => {
                    setSearchSelectedRefVal(e)
                  }}
                  label={'Search Selected References'}
                  isRequired={false}
                  value={searchSelectedRefVal}
                  type={'search'}
                />
              </div>
              <div
                className="flex items-center flex-wrap overflow-y-auto p-2"
                style={{ maxHeight: '50vh' }}
              >
                {references
                  ?.filter((ref) =>
                    ref.new
                      .toLocaleLowerCase()
                      .includes(searchSelectedRefVal.toLocaleLowerCase())
                  )
                  .map((reference, referenceIdx) => {
                    return (
                      <div
                        className={`flex mb-1 justify-between p-1 text-sm border-1 border  bg-tracer-lt-blue items-center flex-row w-full`}
                        key={`reference-${reference.new}`}
                      >
                        <div className="w-3/4 table_text">
                          <Tooltip message={reference.new}>
                            <div>{reference.new}</div>
                          </Tooltip>
                        </div>
                        <div className="w-1/4 cursor-pointer px-2 justify-end flex">
                          <TrashAlt
                            size="1.5rem"
                            color="white"
                            onClick={() =>
                              deleteReference(referenceIdx, reference)
                            }
                          />
                        </div>
                      </div>
                    )
                  })}
                {references?.length < 1 && <NoRecordsFound loading={false} />}
              </div>
            </div>
          </div>
          <div className="flex items-center pt-4 justify-end">
            <button
              onClick={() => {
                saveDuplicateRef()
              }}
              href="#"
              className="cursor-pointer bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-2 rounded text-base"
            >
              ({references?.length}) Save Duplicate References
            </button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default DuplicateReferences
